import React, { PureComponent } from 'react';
import { Platform, View, Image, Text, TextInput, StyleSheet,
         TouchableOpacity, TouchableWithoutFeedback, UIManager } from 'react-native';
import { Container, Content, Button, Left, Body, Right, Title } from "native-base";
import LinearGradient from "react-native-linear-gradient";
import { NavigationService } from "../../navigation";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import MessageBox from "../../components/ui/MessageBox";
import FeedbackSuggestionService from "../../services/screens/me/FeedbackSuggestionService";
import * as Helper from "../../utils/Helper";
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.components.ui.reportWordError;

const isIos = Platform.OS === "ios";

class ReportWordError extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            reportErrorCode: 0,
            description: "",
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    renderReason(reason, index) {
        const selected = (this.state.reportErrorCode === reason.code);
        return (<Button key={index} style={{height: 40, backgroundColor: (selected ? "#cc0000" : "#eee"),
                                            paddingLeft: 20, paddingRight: 20, marginRight: 8, marginBottom: 8,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                        transparent onPress={() => {
                            this.setState({
                                reportErrorCode: selected ? -1 : reason.code,
                                description: "",
                            });
                        }}
                >
                    <Text style={{color: selected ? '#fff' : '#666'}}>{reason.text}</Text>
                </Button>);
    }

    _sendReportError() {
        let reportAPI = null;
        let id = null;
        if (this.props.wordData) {
            reportAPI = FeedbackSuggestionService.reportWordError;
            id = this.props.wordData.origin.chars.join("");
        }
        else if (this.props.letterData) {
            reportAPI = FeedbackSuggestionService.reportLetterError;
            id = this.props.letterData.origin.char;
        }

        if (reportAPI) {
            reportAPI({id: id, errorCode: this.state.reportErrorCode, description: this.state.description},
                      (response) => {
                          //this.setState({reportErrorCode: 0, description: ""});
                          this.props.onClose();
                          MessageBox.success({
                              text: this.props.t("reportSuccess"),
                              duration: 5000
                          });
                      },
                      (response) => {
                          //this.setState({reportErrorCode: 0, description: ""});
                          this.props.onClose();
                          MessageBox.danger({
                              text: this.props.t("reportError"),
                              duration: 5000
                          });
                      });
        }
        else {
            //this.setState({reportErrorCode: 0, description: ""});
            this.props.onClose();
        }
    }

    render() {
        let reasons = [
            {code: 0, text: this.props.t('hasError')},
            {code: 1, text: this.props.t('interpretError')},
            {code: 2, text: this.props.t('phoneticError')},
            {code: 3, text: this.props.t('pronounceError')},
            {code: 4, text: this.props.t('exampleError')},
            {code: 5, text: this.props.t('exampleInterpretError')},
            {code: 6, text: this.props.t('otherError')},
        ];
        if(this.props.webWord){
            reasons = [
                {code: 0, text: this.props.t('hasError')},
                {code: 21, text: this.props.t('pinyinError')},
                {code: 1, text: this.props.t('interpretError')},
                {code: 3, text: this.props.t('pronounceError')},
                {code: 22, text: this.props.t('synonymsOrAntonymsError')},
                {code: 4, text: this.props.t('exampleError')},
                {code: 6, text: this.props.t('otherError')},
            ];
        }
        return (<View style={{zIndex: 10, flexDirection: 'column', position: 'absolute',
                              left: 0, right: 0, top: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <TouchableWithoutFeedback style={{flex: 1}} onPress={() => {
                                                  this.props.onClose();
                                              }}>
                        <View style={{flex: 1}}/>
                    </TouchableWithoutFeedback>
                    <View style={{height: 400, backgroundColor: '#fff', padding: 20}}>
                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <Text style={{fontSize: 20}}>
                                {this.props.t("reportWordError")}
                            </Text>
                        </View>
                        <View style={{marginTop: 20, flexDirection: 'row', flexWrap: "wrap"}}>
                            {reasons.map((reason, index) => {
                                return this.renderReason(reason, index);
                            })}
                        </View>
                        <View style={{flex: 1,}}>
                            {
                                this.state.reportErrorCode === 6 ?
                                    <TextInput ref={"description"}
                                               multiline={true}
                                               onFocus = {this.onFocus}
                                               onChangeText={text => this.setState({ description: text })}
                                               placeholder={this.props.t("otherErrorDescription")}
                                               value={this.state.description}
                                               placeholderTextColor={"#bbbbbb"}
                                               style={{borderWidth:1, height:50, width:"100%", borderRadius:6, borderColor:"#0099FF", paddingTop:10,paddingLeft:10,paddingRight:10, paddingBottom:10}}
                                    />
                                : null
                            }
                        </View>
                        <View style={{flexDirection: 'row', marginTop:10}}>
                            <Button style={{flex: 1, height: 35, backgroundColor: (this.state.reportErrorCode >= 0) ? "#1E90FF" : "#ccc",
                                            marginRight: 8,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                    disabled={this.state.reportErrorCode < 0}
                                    transparent onPress={() => {
                                        this._sendReportError();
                                    }}
                            >
                                <Text style={{color: '#fff'}}>{this.props.t('submit')}</Text>
                            </Button>
                            <Button style={{flex: 1, height: 35, backgroundColor: "#fff", marginLeft: 8,
                                            borderColor: '#333', borderWidth: 1,
                                            borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                    transparent onPress={() => {
                                        //this.setState({showReportError: false, reportErrorCode: 0});
                                        this.props.onClose();
                                    }}
                            >
                                <Text style={{color: '#333'}}>{this.props.t('cancel')}</Text>
                            </Button>
                        </View>
                    </View>
                </View>);
    }
};

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
    },
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
    listContainer: {
        flex: 1,
        padding: 15,
        paddingTop: 0,
    },
    itemTitleStyle: {
        marginBottom: 2,
        fontSize: 18,
        color: "#b6b6b6",
    },
    itemMargin: {
        marginBottom: 10,
    },
    itemTextStyle: {
        color: "#525252",
        fontSize: 13,
        lineHeight: 22,
    },
    itemStyle: {
        padding: 5,
    },
});

export default withTranslation(uid, { withRef: true })(ReportWordError);
